import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import { SettlementPeriodSummary, SettlementPreview } from '../../types/Settlement';

@Injectable()
export class SettlementApiService {
  private readonly settlementsUrl = `${apiConfiguration.baseApiUrl}/settlements`;

  public constructor(private http: HttpClient, private accessService: AccessService) { }

  public async getPreview(month: string): Promise<HttpResponse<SettlementPreview>> {
    return lastValueFrom(this.http.get<HttpResponse<SettlementPreview>>(this.settlementsUrl, {
      headers: this.getHeaders(), params: new HttpParams().set('month', month),
    }));
  }

  public async getPeriods(): Promise<HttpResponse<SettlementPeriodSummary[]>> {
    return lastValueFrom(this.http.get<HttpResponse<SettlementPeriodSummary[]>>(`${this.settlementsUrl}/periods`, { headers: this.getHeaders() }));
  }

  public async closePeriod(month: string): Promise<HttpResponse<SettlementPreview>> {
    return lastValueFrom(this.http.post<HttpResponse<SettlementPreview>>(`${this.settlementsUrl}/${month}/close`, {}, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
